import { NgModule } from '@angular/core';
import { FnMatDatePickerComponent } from './fn-mat-date-picker.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FoundationModule } from '../../foundation.module';

export * from './fn-mat-date-picker.component';

/**
 * Exports the required FnDatePickerComponent to create datePicker Element
 * making them available for import by NgModules that import this module.
 */

@NgModule({
	declarations: [FnMatDatePickerComponent],
	imports: [
		CommonModule,
		FormsModule,
		MatDatepickerModule,
		MatNativeDateModule,
		FoundationModule,
	],
	exports: [FnMatDatePickerComponent],
})
export class FnMatDatePickerModule {}
